<template>
  <div class="flex f-center f-j-center displayer-img">
    <template >
      <img :src="Bg_path"
           @error="hasError()"
           class="blinki-hide"/>
      <div :style="{backgroundSize: 'auto', backgroundImage: 'url('+ Bg_path+'), url(/images/demo.jpg)'}"
           :class="{'path-error':haveError}"
           class="image-box"></div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "image-displayer",
    props: ['cdn_path', 'image_path'],
    data() {
      return {
        haveError:false
      }
    },
    methods:{
      hasError(){
        this.haveError=true
      },
    },
    computed:{
      /**
       * @return {string}
       */
      Bg_path(){
        return this.cdn_path+this.image_path
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/css/theme.scss';

  .card-img {
    width: auto;

  }

  .displayer-img {
    width: 100%;
  }

  .path-error{
    background-color: $primary-bg-color !important;
    border: 1px solid $main-color;
    border-radius: 20px;
  }
</style>
